import { useI18n } from '../../i18n';
import type { TeamMemberRole } from '../../types';

/** The roles of a team member, in the order of the select. The CHECK of
 *  `team_members.role` holds the same two (#661, F17). */
const COACH_ROLES: readonly TeamMemberRole[] = ['head_coach', 'coach'];

/** The select of the role of a coach in a team: the Assign Coach modal and
 *  the Manage Coach modal. A `Field` gives the `id`, so its label names the
 *  select (#665, F66). */
export default function CoachRoleSelect({ value, onChange, disabled, id, required, ...aria }: {
  value: TeamMemberRole;
  onChange: (role: TeamMemberRole) => void;
  disabled?: boolean;
  id?: string;
  required?: boolean;
  'aria-describedby'?: string;
  'aria-invalid'?: boolean | 'true' | 'false';
}) {
  const { t } = useI18n();
  return (
    <select
      id={id}
      required={required}
      aria-describedby={aria['aria-describedby']}
      aria-invalid={aria['aria-invalid']}
      className="input"
      value={value}
      disabled={disabled}
      onChange={e => {
        const next = COACH_ROLES.find(r => r === e.target.value);
        if (next) onChange(next);
      }}
    >
      {COACH_ROLES.map(r => <option key={r} value={r}>{t.roles[r]}</option>)}
    </select>
  );
}
